import React, { Suspense, lazy } from 'react';
import Loader from '~components/main-loader';

const NewsDigestsPage = lazy(() => import('./index'))

function NewsDigestsPageLazy(props) {
    return (
        <Suspense fallback={<Loader/>}>
            <NewsDigestsPage {...props} />
        </Suspense>
    );
}

export default NewsDigestsPageLazy;
export { NewsDigestsPageLazy };



// WEBPACK FOOTER //
// ./src/routes/main/news-digests-item-page/lazy.js